import { Injectable } from "@angular/core";
import { DataService } from "../data.service";

@Injectable()
export class StudyReportAttachFileService {
  constructor(private dataService: DataService) {}

  async getByStudyReportId(studyReportId: number): Promise<ReportAttachFile[]> {
    const param = { studyReportId };
    return await this.dataService
      .get<ReportAttachFile[]>("/reportAttachFile/getByStudyReportId/", param)
      .toPromise();
  }

  async getFile(id: number): Promise<string> {
    const param = { id };
    return await this.dataService
      .get<string>("/reportAttachFile/getReportAttachFile/", param)
      .toPromise();
  }

  async delete(id: number): Promise<boolean> {
    const param = { Id: id };

    return await this.dataService
      .post<boolean>("/reportAttachFile/deleteFile/", param)
      .toPromise();
  }

  async create(
    studyReportId: number,
    fileBase64: string,
    fileName: string
  ): Promise<boolean> {
    const param = {
      FileName: fileName,
      StudyReportId: studyReportId,
      FileBase64: fileBase64,
    };

    return await this.dataService
      .post<boolean>("/reportAttachFile/post", param)
      .toPromise();
  }
}
